module.exports = __webpack_public_path__ + "static/img/banner.d8dec35.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/programme/banner.png
// module id = xH8Y
// module chunks = 1